@if (countdown$ | async; as secondsLeft) {
  <div class="progress-bar-countdown">
    <div class="progress-bar-countdown__progress-container">
      <div class="progress-bar-countdown__bar" [style.width.%]="getClampedProgress(secondsLeft)"></div>
    </div>
    <div class="screen-reader-only" aria-live="polite" aria-atomic="true">
      {{ shouldAnnounceTime ? formatTime(secondsLeft) : '' }}
    </div>
    <div class="progress-bar-countdown__time-remaining" aria-live="off" [attr.aria-label]="ariaProgressLabel">
      {{ formatTime(secondsLeft) }}
    </div>
    <div class="progress-bar-countdown__button-wrapper">
      @if (secondsLeft <= 30 && secondsLeft > 0) {
        <button class="btn btn-active" aria-label="ariaExtendButtonLabel" (click)="onExtend()">
          {{ 'COMMON.EXTEND' | translate }}
        </button>
      }
    </div>
  </div>
}
